import dayjs from 'dayjs'

import { Listings_Detail } from '@/types/cate-graphql-generated-types'

import { isStorageSupported } from './isStorageSupported'

const utc = require('dayjs/plugin/utc')
dayjs.extend(utc)

/**
 * Checks if a listing is new (published within the last 72h and not yet visited)
 * @param listing The listing to check
 * @returns `true` if the listing is new, `false` otherwise
 */
export const checkListingNew = (listing: Listings_Detail): boolean => {
  const isNew = checkListingPublishedIn(listing.publishedAt, 72)
  const hasBeenVisited = checkListingHasBeenVisited(listing.id)

  return !hasBeenVisited && isNew
}

/**
 * Checks if a listing has been pablished in the last `hours`
 * @param publishedAt The publishing date of the listing
 * @param hours The time window to check (in hours)
 * @returns `true` if the listing is has been bublished in the last `hours`, `false` otherwise
 */
export const checkListingPublishedIn = (publishedAt: string, hours: number): boolean =>
  dayjs.utc().diff(dayjs.utc(publishedAt), 'hours') <= hours

/**
 * Checks if a listing has been visited
 * @param listingId The id of the listing to check
 * @returns `true` if the listing has been visited, `false` otherwise
 */

const localStorageVisitedListingKey = '@CASAVO@VISITED-LISTINGS'

export const checkListingHasBeenVisited = (listingId: string): boolean => {
  const visitedListings = getVisitedListings()
  return visitedListings.includes(listingId)
}

const getVisitedListings = (): string[] => {
  const storedVisitedListings =
    isStorageSupported(() => localStorage) && localStorage.getItem(localStorageVisitedListingKey)

  return storedVisitedListings ? JSON.parse(storedVisitedListings) : []
}

export const storePropertyVisited = (listingId: string): void => {
  const visitedListings = getVisitedListings()

  if (!visitedListings.includes(listingId)) {
    visitedListings.push(listingId)
    localStorage.setItem(localStorageVisitedListingKey, JSON.stringify(visitedListings))
  }
}
